import type { ReactElement } from 'react';
import { useRef } from 'react';
import { Card, CardMedia, Stack, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import type {
  MarkdownRemarkFrontmatterAdvantagesCards,
  MarkdownRemarkFrontmatterDeveloperCards,
} from '../../../generated/types';
import { useScrollAnimation } from '../../components/hooks/useScrollAnimation';

type PpHomepageCardWithImage = (
  | MarkdownRemarkFrontmatterAdvantagesCards
  | MarkdownRemarkFrontmatterDeveloperCards
) & {
  darkText?: boolean;
  directionFrom: 'left' | 'right';
};

export function HomepageCardWithImage({
  darkText,
  directionFrom,
  image,
  subtitle,
  title,
}: PpHomepageCardWithImage): ReactElement {
  const containerRef = useRef(null);
  const fromLeft = directionFrom === 'left';
  const { opacity, transform } = useScrollAnimation(containerRef, {
    opacity: [0, 1],
    transform: [`translateX(${fromLeft ? '-100px' : '100px'})`, 'translateX(0px)'],
  });

  return (
    <div ref={containerRef}>
      <motion.div
        style={{
          opacity,
          transform,
        }}
      >
        <Card
          alignItems="center"
          component={Stack}
          direction="row"
          elevation={0}
          sx={{ backgroundColor: 'transparent' }}
        >
          {image && (
            <CardMedia alt={title || ''} component="img" image={image} sx={{ width: 120 }} />
          )}
          <Stack padding={5} spacing={2.5}>
            <Typography color={darkText ? 'text.black' : 'text.white'} variant="paragraphBodyMBold">
              {title}
            </Typography>
            <Typography color={darkText ? 'text.dark' : 'text.light'} variant="paragraphBodyS">
              {subtitle}
            </Typography>
          </Stack>
        </Card>
      </motion.div>
    </div>
  );
}
